import { FETCH_TAGS } from "../actions/Tags";

const initialState = {
  cache: {},
  msg: { msgType: "", text: "", key: "" }
};

export default function tags(state = initialState, action) {
  switch (action.type) {
    case FETCH_TAGS:
      return { ...state, cache: action.payload };
    default:
      return state;
  }
}
